import { render, staticRenderFns } from "./SendLocation.vue?vue&type=template&id=75a9e8f2&scoped=true&"
import script from "./SendLocation.vue?vue&type=script&lang=js&"
export * from "./SendLocation.vue?vue&type=script&lang=js&"
import style0 from "./SendLocation.vue?vue&type=style&index=0&id=75a9e8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a9e8f2",
  null
  
)

export default component.exports